/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmBaseExecuteDocumentRequest {
    getFixupPrototypeFunction() { return AwsSsmBaseExecuteDocumentRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmBaseExecuteDocumentRequest>): AwsSsmBaseExecuteDocumentRequest {
        let obj = Object.assign(new AwsSsmBaseExecuteDocumentRequest(), model);
        AwsSsmBaseExecuteDocumentRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmBaseExecuteDocumentRequest>): AwsSsmBaseExecuteDocumentRequest {
        if (!model) return null;
        return AwsSsmBaseExecuteDocumentRequest.newInstance(<AwsSsmBaseExecuteDocumentRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmBaseExecuteDocumentRequest) {
        if (!obj) return;

        models.AwsSsmBaseExecuteDocumentRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmBaseExecuteDocumentRequest): boolean {
        Object.setPrototypeOf(obj, AwsSsmBaseExecuteDocumentRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.alarm_configuration) {
            models.AwsSsmDocumentAlarmConfiguration.fixupPrototype(this.alarm_configuration);
        }
    }

    /**
     * Cloud Account id  for which command document need to be executed.
     */
    cloud_account_id: string;

    /**
     * Region of the document to be executed.
     */
    region: string;

    /**
     * Name of the document.
     */
    document_name: string;

    /**
     * The SSM document version to use in the request.
     */
    document_version: string;

    /**
     * The cryptographic hash value of the document content.
     */
    document_hash: string;

    /**
     * The hash algorithm used to calculate the hash value
     */
    document_hash_type: models.AwsSsmHashType;

    /**
     * The required and optional parameters specified in the document being run.
     */
    parameters: { [key: string]: Array<string>; };

    /**
     * The maximum number of managed nodes that are allowed to run the command at the same time.
     */
    max_concurrency: string;

    /**
     * The maximum number of errors allowed without the command failing.
     */
    max_errors: string;

    /**
     * The CloudWatch alarm you want to apply to your command.
     */
    alarm_configuration: models.AwsSsmDocumentAlarmConfiguration;

    /**
     * Service Now tracking id
     */
    change_id: string;

}
